<div class="container">
  <div class="row justify-content-center">

    <div class="container header">
      <div class="row justify-content-center">
        <div class="col-2"></div>
        <div class="col-8">
          <h1>Booking summary</h1>
        </div>
        <div class="col-2"></div>
      </div>
    </div>

    <div class="container order-information">
      <div class="row justify-content-center">
        <div class="col-2"></div>
        <div class="col-8">
          <div class="container">
            <div class="row justify-content-center">
              <div class="col-6">Name of customer:</div>
              <div class="col-6 pull-right">{{ partner.name }} [{{partner.dateOfBirth | date:'shortDate'}}]</div>
            </div>
            <div class="row justify-content-center">
              <div class="col-6">Name of bithday child:</div>
              <div class="col-6 pull-right">{{ guestOfHonor.name }} [{{guestOfHonor.dateOfBirth | date:'shortDate'}}]</div>
            </div>
            <div class="row justify-content-center">
              <div class="col-6">Order total:</div>
              <div class="col-6 pull-right">{{ toMoneyStr(order.totalAmount) }}</div>
            </div>
            <div class="row justify-content-center">
              <div class="col-6">Order name:</div>
              <div class="col-6 pull-right">{{ order.name }}</div>
            </div>
          </div>
        </div>
        <div class="col-2"></div>
      </div>
    </div>

    <div class="container information">
      <div class="row justify-content-center">
        <div class="col-1"></div>
        <div class="col-10">
          <h2>Please put down your deposit of 50,- € within one hour at the check-in counter. Should the deposit not be put down
            after 60 minutes, the booking will be cancelled automatically</h2>
        </div>
        <div class="col-1"></div>
      </div>
    </div>

    <div class="container">
      <div class="row justify-content-center">
        <div class="col-4"></div>
        <div class="col-4">
          <app-button title="Complete" (click)="complete()"></app-button>
        </div>
        <div class="col-4"></div>
      </div>
    </div>
  </div>
</div>
